import { render } from "./file.vue?vue&type=template&id=b5e22bc0&scoped=true"
import script from "./file.vue?vue&type=script&lang=js"
export * from "./file.vue?vue&type=script&lang=js"

import "./file.vue?vue&type=style&index=0&id=b5e22bc0&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-b5e22bc0"

export default script